import { makeReparcelingsRepository } from 'modules/customer/infra/repositories';

import { FetchReparcelingByHashUseCase } from './implementations/FetchReparcelingByHashUseCase';

let instance: FetchReparcelingByHashUseCase | null = null;

export default function makeFetchReparcelingByHashUseCase() {
  if (!instance) {
    const repository = makeReparcelingsRepository();

    instance = new FetchReparcelingByHashUseCase(repository);
  }

  return instance;
}
